import { Injectable, inject } from '@angular/core';
import { TokenService } from '../services/token.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, filter, finalize, map, of, switchMap, tap, throwError } from 'rxjs';
import { authResponseDTO } from './models/authResponseDTO';
import { BaseEndpointService } from '../interfaces/IEndpoint';
import { Router } from '@angular/router';
import { getErrorMessage } from './models/errorMap';
import { passwordResetToken } from './components/reset-password/reset-password.component';
import { AuthService } from './auth.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { ToastService } from '../services/toast/toast.service';
import { AuthState } from './state';

export const status = {
  successful: 'SUCCESSFUL',
  failed: 'FAILED',
  notStarted: 'NOT STARTED',
  refreshing: 'IN PROGRESS'
} as const;

type StatusValues = typeof status[keyof typeof status];


interface RefreshResult {
  isRefreshing: boolean;
  status: StatusValues;
}

@Injectable({
  providedIn: 'root',
})
export class AccountService extends BaseEndpointService {

  private readonly authService = inject(AuthState);
  private readonly permissionsService: NgxPermissionsService = inject(NgxPermissionsService);
  private readonly toastService:ToastService = inject(ToastService);


  constructor() {

    super({route: 'account/'})

    this.authService.state.authenticated$
    .pipe(
      filter((value) => value == true),
      switchMap(() => this.roles())
    )
    .subscribe((data: string[]) => {

      this.permissionsService.loadPermissions(data)
    });
  }

  resetPasswordWithToken(model:passwordResetToken)
  {
    return this.http.post(this.endpoint + 'token-password-reset',{
      ...model
    })
  }

  forgotPassword(email)
  {
    return this.http.post(this.endpoint + 'forgot-password', {email})
  }


isAdmin(): Observable<boolean> {
return this.http
  .get<{ isAdmin: boolean }>(this.endpoint + 'is-admin', {
    withCredentials: true,
  })
  .pipe(map((response) => response.isAdmin));
}

roles(): Observable<any> {
return this.http.get(this.endpoint + 'roles', {
  withCredentials: true,
});
}

me(){
return this.http.get(this.endpoint + 'me', {
  withCredentials:true
})
}

resetPassword(model)
{
return this.http.post(`${this.endpoint}reset-password`,{...model}).pipe(tap(() => this.toastService.showSuccess("Password Reset Successfully!")))
}

}
